<template>
  <div class="print-preview">
    <el-dialog v-if="isShow" v-model="isShow" title="打印预览" width="420px" @close="close">
      <div class="receipt-paper">
        <div
          v-for="(line, index) in receiptLines"
          :key="index"
          class="receipt-line"
          :class="{ center: line.center, bold: line.bold }"
        >{{ line.text }}</div>
      </div>
      <template #footer>
        <el-button @click="close">取消</el-button>
        <el-button type="primary" :loading="confirmLoading" @click="handleConfirmClick">确认打印</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="js">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  emits: ['confirm'],
  setup(props, { emit }) {
    const isShow = ref(false)
    const confirmLoading = ref(false)
    const receiptLines = ref([])

    // 解析芯烨云小票内容：<CB>居中加粗、<C>居中、<BR>换行
    const parseContent = (content) => {
      if (!content) {
        return []
      }
      return String(content)
        .split(/<BR>/i)
        .map((raw) => {
          let text = raw
          let center = false
          let bold = false
          const cbMatch = text.match(/^<CB>([\s\S]*)<\/CB>$/i)
          const cMatch = text.match(/^<C>([\s\S]*)<\/C>$/i)
          if (cbMatch) {
            text = cbMatch[1]
            center = true
            bold = true
          } else if (cMatch) {
            text = cMatch[1]
            center = true
          }
          return { text, center, bold }
        })
        .filter((line) => line.text.trim().length > 0)
    }

    const open = (content) => {
      receiptLines.value = parseContent(content)
      confirmLoading.value = false
      isShow.value = true
    }

    const close = () => {
      isShow.value = false
      confirmLoading.value = false
      receiptLines.value = []
    }

    const handleConfirmClick = () => {
      confirmLoading.value = true
      emit('confirm')
    }

    // 打印流程结束后由父组件调用，恢复按钮状态；成功时父组件再调 close
    const resetConfirmLoading = () => {
      confirmLoading.value = false
    }

    return {
      isShow,
      confirmLoading,
      receiptLines,
      open,
      close,
      handleConfirmClick,
      resetConfirmLoading
    }
  }
})
</script>

<style scoped lang="less">
.print-preview {
  .receipt-paper {
    max-height: 55vh;
    overflow-y: auto;
    margin: 0 auto;
    padding: 16px 20px;
    width: 320px;
    background-color: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    font-family: 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.8;
    color: #000;
    white-space: pre-wrap;
    word-break: break-all;
  }

  .receipt-line {
    &.center {
      text-align: center;
    }

    &.bold {
      font-weight: 700;
    }
  }
}
</style>
